import { useSelector } from 'react-redux';
import { useMemo } from 'react';
import { getEntitlements } from '../selectors/getEntitlements';

export const useEntitlements = () => {
    const entitlements = useSelector(getEntitlements);
    return useMemo(() => {
        return entitlements
    }, [entitlements]);
};
